<template>
    <div>
        <b-row>
            <b-col sm="12">
                <b-card no-body>
                    <b-card-header>
                        <span class="h5">Entregas</span>
                    </b-card-header>
                    <b-card-body>
                        <app-tabela
                            idTabela="tblEntregas"
                            :itens="entregas"
                            :campos="campos"
                            :itensPorPagina="itensPorPagina"
                        >
                            <template slot="botoes">
                                <slot name="botoes"></slot>
                            </template>
                            <template slot="descritivo" slot-scope="data">
                                <app-status
                                    v-if="data.manual"
                                    status="ENTREGA MANUAL"
                                ></app-status>
                                {{ data.descritivo }}
                            </template>
                            <template slot="natureza" slot-scope="data">
                                <app-status
                                    :status="data.natureza"
                                ></app-status>
                            </template>
                            <template slot="temAnexos" slot-scope="data">
                                <app-status
                                    :status="data.temAnexos ? 'SIM' : 'NÃO'"
                                ></app-status>
                            </template>
                            <template slot="statusDescr" slot-scope="data">
                                <app-status
                                    :status="data.statusDescr"
                                ></app-status>
                                <span
                                    class="text-info ml-2"
                                    v-if="data.gestorSubstituto"
                                >
                                    <i
                                        class="fa fa-user fa-lg icon-button"
                                        :title="data.gestorSubstituto"
                                    ></i>
                                </span>
                            </template>
                            <!-- <template slot="temRaht" slot-scope="data">
                <app-status :status="data.temRaht ? 'SIM' : 'NÃO'"></app-status>
                            </template>-->
                            <template slot="valorHora" slot-scope="data">{{
                                data.valorHora | currency
                            }}</template>
                            <template slot="statusIdRm" slot-scope="data">
                                <entrega-comprometimento
                                    :entrega="data"
                                    :movimentosServicos="movimentosServicos"
                                    @obterAtualizacao="
                                        $emit('obterAtualizacao')
                                    "
                                ></entrega-comprometimento>
                            </template>
                            <template
                                slot="valorTotalPrevisto"
                                slot-scope="data"
                                >{{
                                    data.valorTotalPrevisto | currency
                                }}</template
                            >
                            <template
                                slot="valorTotalEntregue"
                                slot-scope="data"
                                >{{
                                    data.valorTotalEntregue | currency
                                }}</template
                            >
                            <template slot="dataPrevisao" slot-scope="data">
                                <span v-if="!data.dataPrevisaoReprogramada">{{
                                    $moment(data.dataPrevisao).format(
                                        'DD/MM/YYYY'
                                    )
                                }}</span>
                                <span v-if="data.dataPrevisaoReprogramada"
                                    >{{
                                        $moment(
                                            data.dataPrevisaoReprogramada
                                        ).format('DD/MM/YYYY')
                                    }}
                                    <btn-justificativa-data-previsao-reprogramada
                                        :entrega="data"
                                    >
                                    </btn-justificativa-data-previsao-reprogramada>
                                </span>
                            </template>
                            <template slot="acoes" slot-scope="data">
                                <slot name="entregaAcoes" v-bind="data"></slot>
                                <btn-excluir-entrega-manual
                                    :entrega="data"
                                    :contratacao="contratacao"
                                    :contratacoesServicos="contratacoesServicos"
                                    @obterAtualizacao="
                                        $emit('obterAtualizacao')
                                    "
                                ></btn-excluir-entrega-manual>
                            </template>
                        </app-tabela>
                    </b-card-body>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import EntregaComprometimento from './EntregaComprometimento'
import BtnJustificativaDataPrevisaoReprogramada from './BtnJustificativaDataPrevisaoReprogramada'
import BtnExcluirEntregaManual from './BtnExcluirEntregaManual'

export default {
    components: {
        EntregaComprometimento,
        BtnJustificativaDataPrevisaoReprogramada,
        BtnExcluirEntregaManual
    },

    props: {
        entregas: {
            type: Array,
            default: () => []
        },

        movimentosServicos: {
            type: Object,
            default: () => ({})
        },

        contratacao: {
            type: Object,
            default: () => ({})
        },

        contratacoesServicos: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            campos: [
                {
                    key: 'descritivo',
                    label: 'Descritivo',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'natureza',
                    label: 'Natureza',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'valorHora',
                    label: 'Valor',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'dataPrevisao',
                    label: 'Previsão de Entrega',
                    sortable: true,
                    type: 'date',
                    tdClass: 'text-center'
                },
                {
                    key: 'cargaHorariaPrevista',
                    label: 'CH Prev.',
                    tdClass: 'text-center'
                },
                {
                    key: 'valorTotalPrevisto',
                    label: 'Total',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'dataEntrega',
                    label: 'Entrega',
                    sortable: true,
                    type: 'date',
                    tdClass: 'text-center'
                },
                {
                    key: 'cargaHorariaEntregue',
                    label: 'CH Entr.',
                    tdClass: 'text-center'
                },
                {
                    key: 'valorTotalEntregue',
                    label: 'Total Entregue',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'temAnexos',
                    label: 'Anexos',
                    tdClass: 'text-center'
                },
                {
                    key: 'statusDescr',
                    label: 'Status',
                    type: 'status'
                },
                {
                    key: 'statusIdRm',
                    label: 'Comprometimento'
                },
                {
                    key: 'registroPagamento',
                    label: 'Protocolo de Pagamento'
                },
                {
                    key: 'dataAtualizacao',
                    label: 'Atualizado em',
                    type: 'datetime',
                    tdClass: 'text-center'
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 0
        }
    },

    methods: {},

    computed: {},

    created() {}
}
</script>
